import { useEffect, useState } from "react";
import Nav from "@/components/Header/Nav/Nav.tsx";
import Header from "@/components/Header/Header.tsx";
import Footer from "@/components/Footer/Footer.tsx";
import ScrollingText from "@/components/ScrollingText";
import GridComponent from "@/components/GridComponent/GridComponent";
import OpenMenuBlock from "@/components/OpenMenuBlock/OpenMenuBlock";
import ServiceBlockBerlin from "@/components/ServiceBlockBerlin/ServiceBlockBerlin";
import { useTranslation } from "react-i18next";
import FaqBlock from "@/components/FAQ/FAQBlock";
import CookiePopupButton from "../components/CookieBanner/CookiePopupButton";
import { getFaqDataBerlin } from "@/data/faq/data-faq-index"; // Імпорт функції для отримання FAQ
import RepairService from "../components/RepairService/RepairService";
import { Helmet } from "react-helmet-async";

interface SliderImage {
  src1920: string;
  src1440: string;
  src768: string;
  src320: string;
  alt: string;
  imageType: "full" | "partial";
  className?: string;
}

const headerSlider: SliderImage[] = [
  {
    src1920: "/images/Berlin/slide1_1920.webp",
    src1440: "/images/Berlin/slide1_1440.webp",
    src768: "/images/Berlin/slide1_768.webp",
    src320: "/images/Berlin/slide1_320.webp",
    alt: "Slide 1",
    imageType: "partial",
    className: "slide1-berlin",
  },
  {
    src1920: "/images/Berlin/slide2_1920.webp",
    src1440: "/images/Berlin/slide2_1440.webp",
    src768: "/images/Berlin/slide2_768.webp",
    src320: "/images/Berlin/slide2_320.webp",
    alt: "Slide 2",
    imageType: "partial",
  },
  {
    src1920: "/images/Berlin/slide3_1920.webp",
    src1440: "/images/Berlin/slide3_1440.webp",
    src768: "/images/Berlin/slide3_768.webp",
    src320: "/images/Berlin/slide3_320.webp",
    alt: "Slide 3",
    imageType: "partial",
    className: "slide3-berlin",
  },
];

const ServiceBerlin = () => {
  const { t } = useTranslation("pages");

  // Створюємо стан для faqData
  const [faqData, setFaqData] = useState<
    { question: string; answer: string }[] | null
  >(null);

  useEffect(() => {
    // Завантажуємо faqData при монтуванні компонента
    const fetchFaqData = async () => {
      const data = await getFaqDataBerlin(); // Отримуємо дані через асинхронну функцію
      setFaqData(data); // Зберігаємо їх у стан
    };
    fetchFaqData(); // Викликаємо функцію для завантаження
  }, []); // Порожній масив залежностей означає, що ефект виконується лише один раз при монтуванні компонента

  useEffect(() => {
    window.scrollTo(0, 0); // Прокручування сторінки на верх при монтуванні
  }, []);

  const gridItems = t("serviceBerlin.grid.items", {
    returnObjects: true,
  }) as Array<{
    title: string;
    description: string;
  }>;

  const gridData = [
    {
      icon: "/images/Grid/superman-ico.svg",
      title: gridItems[0].title,
      description: gridItems[0].description,
    },
    {
      icon: "/images/Grid/graph-ico.svg",
      title: gridItems[1].title,
      description: gridItems[1].description,
    },
    {
      icon: "/images/Grid/chckcar-ico.svg",
      title: gridItems[2].title,
      description: gridItems[2].description,
    },
    {
      icon: "/images/Grid/cert-ico.svg",
      title: gridItems[3].title,
      description: gridItems[3].description,
    },
    {
      icon: "/images/Grid/garant-ico.svg",
      title: gridItems[4].title,
      description: gridItems[4].description,
    },
    {
      icon: "/images/Grid/target-ico.svg",
      title: gridItems[5].title,
      description: gridItems[5].description,
    },
  ];

  const servicesData = t("serviceBerlin.services", {
    returnObjects: true,
  }) as Array<{
    title: string;
    description: string;
    list: string[];
  }>;

  const services = servicesData.map((service, index) => ({
    id: `0${index + 1}`,
    title: service.title,
    description: service.description,
    list: service.list,
  }));

  if (!faqData) {
    return <div>Loading...</div>; // Показуємо завантаження, поки дані не завантажені
  }

  return (
    <div>
      <Helmet>
        <title>{t("serviceBerlin.meta.title")}</title>
      </Helmet>
      <Nav />
      <Header images={headerSlider} />
      <ScrollingText />
      <GridComponent title={t("serviceBerlin.grid.title")} items={gridData} />
      <ServiceBlockBerlin services={services} berlin={true} />
      <RepairService />
      <OpenMenuBlock />
      <FaqBlock faqData={faqData} showAllButton={true} variant="mini" />
      <CookiePopupButton />
      <Footer />
    </div>
  );
};

export default ServiceBerlin;
